import { BooleanGambit } from 'flarum/common/query/IGambit';
import app from 'flarum/common/app';
export default class LockedGambit extends BooleanGambit {
  key() {
    return app.translator.trans('flarum-lock.lib.gambits.discussions.locked.key', {}, true);
  }
  canonicalKey() {
    return 'locked';
  }
  filterKey() {
    return 'locked';
  }
}
flarum.reg.add('flarum-lock', 'common/query/discussions/LockedGambit', LockedGambit);